module.exports = __webpack_public_path__ + "static/media/back-arrow-icon.4bc069b8.svg";